import React from 'react';

import {useCloseableDropdownContext} from 'ui-library/dropdowns/CloseableDropdownContext';

/**
 * This wrapper injects the helper function to allow the submenu items to close
 * the upstream Dropdown. The useCloseableDropdownContext hook cannot be called
 * directly in SearchableMenu because it is a class component.
 */
export interface DropdownCloseControlProps {
  _onCloseDropdown?: () => void;
}

export default function withDropdownCloseControl<P extends DropdownCloseControlProps>(
  WrappedComponent: React.ComponentType<P>
) {
  return function ComponentWithDropdownCloseControl(
    props: Omit<P, keyof DropdownCloseControlProps>
  ): JSX.Element {
    const {onCloseDropdown} = useCloseableDropdownContext();
    // The componentProps must be cast to P since typescript cannot infer the type when an Omit is used
    const componentProps = {...props, _onCloseDropdown: onCloseDropdown} as P;
    return <WrappedComponent {...componentProps} />;
  };
}
